export default "__VITE_ASSET__D1vCG5OX__"